export default __webpack_public_path__ + "static/media/Brain-background-hero-light_5.851614f0.mp4";